import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/defaults/tenant.defaults.query.gql"
import type {
  TenantDefaultsQuery,
  TenantDefaultsQueryVariables,
} from "@/v2-backoffice-client/tenant/defaults/__types__/tenant.defaults.query"

type Options = QueryHookOptions<
  TenantDefaultsQuery,
  TenantDefaultsQueryVariables
>

export function useTenantDefaultsQuery(options?: Options) {
  return useQuery<TenantDefaultsQuery, TenantDefaultsQueryVariables>(
    query,
    options,
  )
}
